export default __webpack_public_path__ + "static/media/speedometer.b90c4eb5.svg";